/** Reserved formData key — client-only; stripped before submit. */
export const EXTERNAL_API_VALIDATION_STAMP_KEY = '__pfExtApiValidation';
